// extracted by mini-css-extract-plugin
export default {"button":"go-to-all-tasks_button__t4yI2"};